import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { VehicleRestitutionReturnStep } from "./vehicleRestitutionReturnStep";
import { VehicleRestitutionConditionStep } from "./vehicleRestitutionConditionStep";
import { VehicleRestitutionSummaryStep } from "./vehicleRestitutionSummaryStep";

type RestitutionStep = "return" | "condition" | "summary";

export const VehicleRestitutionPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<RestitutionStep>("return");
  const [departureLocation, setDepartureLocation] = useState("");
  const [furthestDestination, setFurthestDestination] = useState("");
  const [mileage, setMileage] = useState("");
  const [isCabinCleaned, setIsCabinCleaned] = useState(false);
  const [isTrunkCleaned, setIsTrunkCleaned] = useState(false);
  const [observations, setObservations] = useState("");

  console.log("departureLocation", departureLocation);
  console.log("furthestDestination", furthestDestination);
  console.log("mileage", mileage);
  console.log("isCabinCleaned", isCabinCleaned);
  console.log("isTrunkCleaned", isTrunkCleaned);
  console.log("observations", observations);

  switch (step) {
    case "return":
      return (
        <VehicleRestitutionReturnStep
          departureLocation={departureLocation}
          setDepartureLocation={setDepartureLocation}
          furthestDestination={furthestDestination}
          setFurthestDestination={setFurthestDestination}
          mileage={mileage}
          setMileage={setMileage}
          onReturn={() => navigate(-1)}
          onSubmit={() => setStep("condition")}
        />
      );
    case "condition":
      return (
        <VehicleRestitutionConditionStep
          isCabinCleaned={isCabinCleaned}
          setIsCabinCleaned={setIsCabinCleaned}
          isTrunkCleaned={isTrunkCleaned}
          setIsTrunkCleaned={setIsTrunkCleaned}
          observations={observations}
          setObservations={setObservations}
          onReturn={() => setStep("return")}
          onValidate={() => setStep("summary")}
        />
      );
    case "summary":
      return (
        <VehicleRestitutionSummaryStep
          departureLocation={departureLocation}
          furthestDestination={furthestDestination}
          mileage={mileage}
          isCabinCleaned={isCabinCleaned}
          isTrunkCleaned={isTrunkCleaned}
          observations={observations}
        />
      );
  }
};
